import { redirectToDashboard } from "@/utils/redirects";
import { useEffect } from "react";

/**
 * The Sphere Viewer has no home page of its own, so the root url sends the user to the Dashboard.
 * Components embedded in the Viewer (e.g. the Data Management error boundary) navigate to "/" when
 * they offer a "home" action, so this route has to be a working exit instead of an error page.
 *
 * @returns nothing, it only triggers the redirect
 */
export function HomeRedirect(): null {
  useEffect(() => {
    redirectToDashboard();
  }, []);

  return null;
}
